import store from '@/store'
import storage from '@/lib/storage'

export const Functionality = {
  AS_FREE: 'AsFree',
  AS_STANDARD: 'AsStandard',
  AS_PLUS: 'AsPlus',
  AS_PROFESSIONAL: 'AsProfessional',
}

export default class UserInfo {
  static get() {
    if (store.getters.userInfo) {
      return store.getters.userInfo
    }
    return storage.getUserInfo()
  }

  static getUsername() {
    const userInfo = UserInfo.get()
    if (userInfo) {
      return userInfo.username
    }
    return null
  }

  static isAdmin() {
    const userInfo = UserInfo.get()
    if (userInfo) {
      return userInfo.systemAdmin
    }
    return false
  }

  static isImpersonating() {
    if (UserInfo.getImpersonatingUsername()) {
      return true
    }
    return false
  }

  static getImpersonatingUsername() {
    const userInfo = UserInfo.get()
    if (userInfo) {
      return userInfo.impersonatingUsername
    }
    return null
  }

  static getImpersonatingNickname() {
    const userInfo = UserInfo.get()
    if (userInfo) {
      return userInfo.impersonatingNickname
    }
    return null
  }

  static getNickname() {
    const userInfo = UserInfo.get()
    if (userInfo) {
      return userInfo.nickname
    }
    return 'unknown'
  }

  static getIconUrl() {
    const userInfo = UserInfo.get()
    if (userInfo) {
      return userInfo.iconUrl
    }
    return null
  }

  static getIcon() {
    const userInfo = UserInfo.get()
    if (userInfo) {
      return userInfo.icon
    }
    return null
  }

  static getEmail() {
    const userInfo = UserInfo.get()
    if (userInfo) {
      return userInfo.email
    }
    return null
  }

  static getLanguage() {
    const userInfo = UserInfo.get()
    if (userInfo) {
      return userInfo.language
    }
    return null
  }

  static getCustomIconUrl() {
    const userInfo = UserInfo.get()
    if (userInfo) {
      return userInfo.customIconUrl
    }
    return null
  }

  static isTrialAvailable() {
    const userInfo = UserInfo.get()
    if (userInfo) {
      return userInfo.trialAvailable
    }
    return false
  }

  static getFunctionality() {
    const userInfo = UserInfo.get()
    if (userInfo) {
      return userInfo.functionality
    }
    return null
  }

  static hasStandardFunctionality() {
    const f = UserInfo.getFunctionality()
    if (f) {
      return f === Functionality.AS_STANDARD
    }
    return false
  }

  static hasFreeFunctionality() {
    const f = UserInfo.getFunctionality()
    if (f) {
      return f === Functionality.AS_FREE
    }
    return false
  }

  static hasPlusFunctionality() {
    const f = UserInfo.getFunctionality()
    if (f) {
      return f === Functionality.AS_PLUS
    }
    return false
  }

  static hasProfessionalFunctionality() {
    const f = UserInfo.getFunctionality()
    if (f) {
      return f === Functionality.AS_PROFESSIONAL
    }
    return false
  }

  static isFSMigrated() {
    const userInfo = UserInfo.get()
    if (userInfo) {
      // return userInfo.isFsMigrated // isはつかない
      return userInfo.fsMigrated
    }
    return false
  }

  static isOAuthUser() {
    const userInfo = UserInfo.get()
    if (userInfo) {
      return userInfo.oauthUser
    }
  }

  static isPasswordEntered() {
    const userInfo = UserInfo.get()
    if (userInfo) {
      return userInfo.passwordEntered
    }
  }
}
